import React, { useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import { KIND_ICON } from "@/components/chef/crm/crmUtils";

// Phase 67 — saisie rapide d'une activité (note / appel / email / rendez-vous / tâche) sur un contact ou une opportunité
export function ActivityForm({ contactId, opportunityId, kinds, onAdded }) {
  const [kind, setKind] = useState("note");
  const [content, setContent] = useState("");
  const [due, setDue] = useState("");
  const [busy, setBusy] = useState(false);
  const needsDue = kind === "tache" || kind === "rdv";

  const add = async () => {
    if (!content.trim()) return toast.error("Décrivez l'activité");
    if (needsDue && !due) return toast.error("Indiquez une échéance");
    setBusy(true);
    try { await api.post("/chef/crm/activities", { contact_id: contactId || null, opportunity_id: opportunityId || null, kind, content, due_at: due ? new Date(due).toISOString() : null }); toast.success(needsDue ? "Tâche planifiée" : "Activité enregistrée"); setContent(""); setDue(""); onAdded(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="border border-[#DEE2E6] bg-[#F8F9FA] p-3 space-y-2" data-testid="crm-activity-form">
      <div className="flex flex-wrap gap-1" data-testid="crm-activity-kinds">
        {Object.entries(kinds).map(([k, l]) => { const I = KIND_ICON[k]; return <button key={k} type="button" onClick={() => setKind(k)} data-testid={`crm-activity-kind-${k}`} className={`inline-flex items-center gap-1 px-2 py-1 text-[11px] font-bold border ${kind === k ? "bg-[#0A0A0A] text-white border-[#0A0A0A]" : "border-[#DEE2E6] bg-white hover:border-[#0A0A0A]"}`}><I className="h-3 w-3" />{l}</button>; })}
      </div>
      <Textarea value={content} onChange={(e) => setContent(e.target.value)} rows={2} data-testid="crm-activity-content" placeholder={kind === "tache" ? "Ex. : Relancer par téléphone pour le devis" : kind === "rdv" ? "Ex. : Visite du site avec le client" : "Compte-rendu, information utile…"} className="bg-white" />
      <div className="flex flex-wrap items-center gap-2">
        <Input type="datetime-local" value={due} onChange={(e) => setDue(e.target.value)} data-testid="crm-activity-due" className="h-9 w-[210px] bg-white" aria-label="Échéance" />
        <span className="text-[11px] text-[#868E96]">{needsDue ? "Échéance obligatoire — apparaîtra dans vos tâches" : "Échéance facultative (crée une tâche à faire)"}</span>
        <Button size="sm" onClick={add} disabled={busy} data-testid="crm-activity-add" className="ml-auto h-9 bg-[#002FA7] hover:bg-[#002175] text-white"><Plus className="h-4 w-4 mr-1" />Ajouter</Button>
      </div>
    </div>
  );
}
